import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import FieldValue from './FieldValue';

import './TimeField.scss';

export default function TimeField({ style, label, value, onChange, error }) {
  return (
    <FieldValue
      style={style}
      className="form-time-field"
      label={label}
      error={error}
    >
      <DatePicker
        selected={new Date((value ? moment(value, 'HH:mm:ss') : moment()).valueOf())}
        onChange={(obj) => {
          onChange({ target: { value: moment(obj).format('HH:mm:ss') } });
        }}
        showTimeSelect
        showTimeSelectOnly
        dateFormat="hh:mm a"
        timeCaption="Time"
      />
    </FieldValue>
  );
}

TimeField.propTypes = {
  style: PropTypes.shape(),
  label: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
};

TimeField.defaultProps = {
  style: {},
  label: '',
  value: '00:00 am',
  error: null,
};
